import { connect } from 'react-redux'
import Notification from 'store/Notification'

const Error = ({ addNotification, message }) => {
  addNotification(message)
  return null
}

const mapDispatchToProps = dispatch => ({
  addNotification: message => dispatch(Notification.error(message)),
})

export default connect(null, mapDispatchToProps)(Error)



// WEBPACK FOOTER //
// ./src/components/UI/Notifications/Error.jsx